import { Box, Text } from '@chakra-ui/react';
import { FC } from 'react';
import { JumbotronProps } from './Jumbotron.props';

const Jumbotron: FC<JumbotronProps> = ({ title }) => (
  <Box minH={300} pt={150} style={{ backgroundColor: 'rgb(13, 21, 60)' }}>
    <Text as="h1" fontSize="3rem" color="#fff" align="center">
      {title}
    </Text>
  </Box>
);

export { Jumbotron };
